import React from 'react';
import { Button } from '@mui/material';
import { Box, Typography, Divider } from '@mui/material';

interface SteamLoginButtonProps {
  onLoginSuccess: (user: any) => void;
  redirectPath: string;
}

const SteamLoginButton: React.FC<SteamLoginButtonProps> = ({ onLoginSuccess, redirectPath }) => {
  const handleSteamLogin = () => {
    const steamUrl = `${process.env.REACT_APP_API_URL}/auth/steam/login?redirect_uri=${encodeURIComponent(
      `${process.env.REACT_APP_FRONTEND_URL}/auth/steam/callback?mode=login`
    )}`;
    
    window.location.href = steamUrl;
  };

  return (
    <>
      <Box sx={{ width: '100%', mt: 3, mb: 2, display: 'flex', alignItems: 'center' }}>
        <Divider sx={{ flex: 1 }} />
        <Typography 
          variant="caption" 
          sx={{ 
            color: 'text.secondary',
            fontSize: '0.65rem',
            lineHeight: '1.2',
          }}
        >
          PULSEライブラリと同期・連携済みのSteamアカウントでログインすることもできます
        </Typography>
        <Divider sx={{ flex: 1 }} />
      </Box>

      <Button
        variant="outlined"
        onClick={handleSteamLogin}
        startIcon={
          <img 
            src="/icons/service/source/steam_.svg" 
            alt="Steam" 
            style={{ width: '20px', height: '20px', filter: 'invert(1)' }}
          />
        }
        fullWidth
        sx={{
          borderColor: 'rgba(255, 255, 255, 0.12)',
          color: 'text.primary',
          background: 'linear-gradient(135deg, rgba(23, 26, 33, 0.1), rgba(42, 71, 94, 0.1))',
          '&:hover': {
            borderColor: 'rgba(255, 255, 255, 0.2)',
            background: 'linear-gradient(135deg, rgba(23, 26, 33, 0.15), rgba(42, 71, 94, 0.15))'
          },
          textTransform: 'none',
          fontWeight: 500,
          py: 1,
          backdropFilter: 'blur(8px)',
          transition: 'all 0.2s ease',
          position: 'relative',
          overflow: 'hidden',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'linear-gradient(135deg, rgba(25, 29, 39, 0.4), rgba(42, 71, 94, 0.4))',
            zIndex: -1
          }
        }}
      >
        Steamでログイン
      </Button>
    </>
  );
};

export default SteamLoginButton;
